import { getRouteApi } from '@tanstack/react-router';
import * as React from 'react';

import { PublicationScreen } from '@/routes/admin/campaigns/publication-screen';

// =============================================================================
// publication-route.tsx — Adaptateur routeur de l'écran « Publication du benchmark » (S18 / stream C).
// =============================================================================
// L'id de campagne est le path param d'URL (« /admin/campaigns/$campaignId/publication ») — ressource d'URL,
// cohérent avec le contrat API (campaignId server-set, invariant n°1). Le composant de présentation reste
// testable hors routeur.

const routeApi = getRouteApi('/admin/campaigns/$campaignId/publication');

export function PublicationRoute(): React.JSX.Element {
  const { campaignId } = routeApi.useParams();

  return <PublicationScreen campaignId={campaignId} />;
}
